jQuery( function ($) {

  var ProductDataHandler = function() {
    this.fetchProductData('shopping-list');
    this.fetchProductData('hot-deals');
    this.fetchProductData('previously-ordered');
    this.fetchProductData('favourites', [{dataType: 'favourites-menu', limit: 6}]);
  }

  ProductDataHandler.prototype.fetchProductDataServer = function(dataType, additionalRender = []) {
    let dataHandler = this;
    let data_object = {
      nonce: product_data_ajax_var.nonce,
      data_type: dataType,
      action: 'penkeths_product_data'
    };
    $.ajax({
      url: product_data_ajax_var.url,
      data: $.param(data_object), // form data
      type: 'POST', // POST
      beforeSend: function (xhr) {
      },
      success: function (data) {
        let results = JSON.parse(data);
        if (results.success) {
          dataHandler.saveProductDataLocalStorage(dataType, results);
          dataHandler.renderProductData(dataType, additionalRender);
        }
      },
      error: function (XMLHttpRequest, status, errorMessage) {
      }
    });
  }

  ProductDataHandler.prototype.fetchProductDataLocalStorage = function(dataType) {
    return JSON.parse(localStorage.getItem('penkeths_data_' + dataType)) || [];
  }

  ProductDataHandler.prototype.saveProductDataLocalStorage = function(dataType, data) {
    localStorage.setItem('penkeths_data_' + dataType, JSON.stringify(data));
    localStorage.setItem('penkeths_data_' + dataType + '_timestamp', JSON.stringify({
      time: Date.now(),
      user_id: product_data_ajax_var.user_id
    }));
  }

  ProductDataHandler.prototype.fetchProductData = function(dataType, additionalRender = []) {
    if (!this.checkProductDataLocalStorage(dataType)) {
      this.fetchProductDataServer(dataType, additionalRender);
    } else {
      this.renderProductData(dataType, additionalRender);
    }
  }

  ProductDataHandler.prototype.checkProductDataLocalStorage = function(dataType) {
    if (localStorage.getItem('penkeths_data_' + dataType + '_timestamp')) {
      let timeData = JSON.parse(localStorage.getItem('penkeths_data_' + dataType + '_timestamp'));
      let heartBeatTime = Cookies.get('penkeths_data_' + dataType + '_heart_beat') ? JSON.parse(Cookies.get('penkeths_data_' + dataType + '_heart_beat')) : null;
      if (timeData.time < (Date.now() - 24 * 60 * 60 * 1000) || timeData.user_id != product_data_ajax_var.user_id || (heartBeatTime && timeData.time < heartBeatTime.time)) {
        return false;
      }
      return true;
    }
    return false;
  }

  ProductDataHandler.prototype.renderProductData = function(dataType, additionalRender = []) {
    let dataHandler = this;
    let data = this.fetchProductDataLocalStorage(dataType);
    //console.log(data);
    let template = this.fetchProductDataTemplate(dataType);
    let draw = $("[data-template-block-list=" + dataType + "]");
    if (data.data.items) {
      data.data.items.forEach(
        function(item) {
          //console.log(item);
          let itemTemplate = template.clone();
          itemTemplate.find("[data-template_field=link]").attr("href", item.link);
          itemTemplate.find("[data-template_field=image]").attr("src", item.image[0]);
          itemTemplate.find("[data-template_field=title]").attr("href", item.link);
          itemTemplate.find("[data-template_field=title]").html(item.title);
          //itemTemplate.find("[data-template_field=price]").append(item.price);
          itemTemplate.find("[data-template_field=price_html]").replaceWith(item.price_html);
          if (item.has_options) {
            itemTemplate.find("[data-template_field=click-for-options]").attr("href", item.link);
            itemTemplate.find("[data-template_field=click-for-options]").attr("data-product_id", item.id);
            itemTemplate.find("[data-template_field=click-for-options]").attr("data-product_sku", item.sku);
            itemTemplate.find("[data-template_field=add-to-cart]").hide();
            itemTemplate.find("[data-template_field=quantity-wrapper]").hide();
          } else {
            itemTemplate.find("[data-template_field=add-to-cart]").attr("href", "?add-to-cart=" + item.id);
            itemTemplate.find("[data-template_field=add-to-cart]").attr("data-product_id", item.id);
            itemTemplate.find("[data-template_field=add-to-cart]").attr("data-product_sku", item.sku);
            itemTemplate.find("[data-template_field=click-for-options]").hide();
          }
          draw.append(itemTemplate);
        });
      template.hide();
    }
    if (additionalRender) {
      additionalRender.forEach(function(additionalRenderData){
        let additionalDataType = additionalRenderData.dataType;
        let template = dataHandler.fetchProductDataTemplate(additionalDataType);
        let draw = $("[data-template-block-list=" + additionalDataType + "]");
        if (data.data.items) {
          data.data.items.slice(0, additionalRenderData.limit).forEach(
            function(item) {
              //console.log(item);
              let itemTemplate = template.clone();
              itemTemplate.find("[data-template_field=link]").attr("href", item.link);
              itemTemplate.find("[data-template_field=image]").attr("src", item.image[0]);
              itemTemplate.find("[data-template_field=title]").attr("href", item.link);
              itemTemplate.find("[data-template_field=title]").html(item.title);
              //itemTemplate.find("[data-template_field=price]").append(item.price);
              itemTemplate.find("[data-template_field=price_html]").replaceWith(item.price_html);
              if (item.has_options) {
                itemTemplate.find("[data-template_field=click-for-options]").attr("href", item.link);
                itemTemplate.find("[data-template_field=click-for-options]").attr("data-product_id", item.id);
                itemTemplate.find("[data-template_field=click-for-options]").attr("data-product_sku", item.sku);
                itemTemplate.find("[data-template_field=add-to-cart]").hide();
                itemTemplate.find("[data-template_field=quantity-wrapper]").hide();
              } else {
                itemTemplate.find("[data-template_field=add-to-cart]").attr("href", "?add-to-cart=" + item.id);
                itemTemplate.find("[data-template_field=add-to-cart]").attr("data-product_id", item.id);
                itemTemplate.find("[data-template_field=add-to-cart]").attr("data-product_sku", item.sku);
                itemTemplate.find("[data-template_field=click-for-options]").hide();
              }
              draw.append(itemTemplate);
            });
        }
        template.hide();
      });
    }
  }

  ProductDataHandler.prototype.fetchProductDataTemplate = function(dataType) {
    let draw = $("[data-template-block-list=" + dataType + "]");
    let template = draw.children(".draw-template-block");
    return template;
  }

  new ProductDataHandler();
});
